import { render, staticRenderFns } from "./detailInfo.vue?vue&type=template&id=ef0c6cb6&scoped=true&"
import script from "./detailInfo.vue?vue&type=script&lang=ts&"
export * from "./detailInfo.vue?vue&type=script&lang=ts&"
import style0 from "./detailInfo.vue?vue&type=style&index=0&id=ef0c6cb6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0c6cb6",
  null
  
)

export default component.exports